module.exports = __webpack_public_path__ + "static/media/wave04.b54afcc6.webp";